import dayjs from "dayjs";
import "dayjs/locale/fr";
import "dayjs/locale/de";
import "dayjs/locale/es";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const DAYJS_LOCALES = ["en", "fr", "de", "es"];

i18n.on("languageChanged", (language) => {
  const locale = language.slice(0, 2);

  dayjs.locale(DAYJS_LOCALES.includes(locale) ? locale : "en");
});

i18n
  .use(LanguageDetector)
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    defaultNS: "translation",
    ns: ["auth"],
    supportedLngs: ["en", "fr", "de", "es"],
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/localization/{{lng}}/{{ns}}.json",
    },
  });
